import React, { useState, useEffect } from 'react'
import { InputText } from "primereact/inputtext";
import { Checkbox } from 'primereact/checkbox';
const TerminationLogic = ({ question, onChange }) => {
  // Initialize termination logic state
  const [terminationLogic, setTerminationLogic] = useState(
    question.terminateLogic || { relatedAnswer: {} }
  );

  // Handle checkbox changes
  const handleCheckboxChange = (optionValue) => {
    const updatedLogic = {
      ...terminationLogic,
      relatedAnswer: {
        ...terminationLogic.relatedAnswer,
        [optionValue]: !terminationLogic.relatedAnswer[optionValue]
      }
    };
    setTerminationLogic(updatedLogic);
    onChange(updatedLogic); // Send updated logic to parent
  };

  return (
<div className="col-12">
  {/* Question Section */}
  <div className="row mb-4">
    <div className="col-12"> 
      <div className="form-group">
        <label className="form-label fw-bold">Question Text</label>
   
         
           <InputText style={{ 'fontSize': 'normal',  'width': '100%' }} name="question"
          readOnly
          value={question.questionText} autoResize={true}
        />
        
      </div>
    </div>
  </div>

  {/* Termination Options Section */}
  <div className="row">
    <div className="col-12">
     
      <div className="alert alert-info mb-4">
        <i className="pi pi-info-circle me-2"></i>
        Select which options should terminate the survey when chosen by respondents.
      </div>

      <div className="table-responsive">
        <table className="table table-hover bg-white rounded">
          <thead className="table-light">
            <tr>
              <th width="70%">Option</th>
              <th width="30%" className="text-center">Terminate if selected</th>
            </tr>
          </thead>
          {/* <tbody>
            {question.choices?.map((choice, index) => (
              <tr key={index}>
                <td>
                  <div>
                     <InputText
                  value={choice.text || choice.value}
                  readOnly
                 className='w-100'
                />
                  </div>
                </td>
                <td className="text-center align-middle">
                  {terminationLogic.relatedAnswer[choice.value] ? (
                    <button 
                      className="btn btn-sm btn-danger"
                      onClick={() => handleCheckboxChange(choice.value)}
                    >
                      <i className="pi pi-times me-1"></i> Remove Termination
                    </button>
                  ) : (
                    <button 
                      className="btn btn-sm btn-success"
                      onClick={() => handleCheckboxChange(choice.value)}
                    >
                      <i className="pi pi-check me-1"></i> Set as Terminating
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody> */}

          <tbody>
  {question.choices?.map((choice, index) => (
    <tr key={index}>
      <td className="p-2">
         <InputText
                  value={choice.text || choice.value}
                  readOnly
                 className='w-100'
                />
      </td>
      <td className="text-center align-middle">
        <input
          type="checkbox"
          style={{ width: '20px', height: '20px' }}
          checked={!!terminationLogic.relatedAnswer[choice.value]}
          onChange={() => handleCheckboxChange(choice.value)}
        />
      </td>
    </tr>
  ))}
</tbody>
        </table>
      </div>
    </div>
  </div>

 
</div>
  );
}

export default TerminationLogic